import { render, staticRenderFns } from "./Loginv2.vue?vue&type=template&id=653d71f8&scoped=true"
import script from "./Loginv2.vue?vue&type=script&lang=js"
export * from "./Loginv2.vue?vue&type=script&lang=js"
import style0 from "./Loginv2.vue?vue&type=style&index=0&id=653d71f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653d71f8",
  null
  
)

export default component.exports